export async function confirmDelete(message = "Are you sure you want to delete this item?") {
    return new Promise((resolve) => {
        const isConfirmed = window.confirm(message);
        resolve(isConfirmed);
    });
}
